module.exports = __webpack_public_path__ + "static/media/vero.d67793c3.png";